<script>
import swal from "sweetalert";

export default {
  name: "add-api-key-modal",
  props: ["api_key"],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    async onSubmit() {

    }
  }
};
</script>

<template>
  <b-modal
      id="modal-add-api-key"
      ref="modal-add-api-key"
      title="Add API Key"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
  >

    <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        enctype="multipart/form-data"
        id="form-modal-add-api-key" 
    >
      <b-form-group label="API Key">
        <b-form-input v-model.trim="api_key" required readonly></b-form-input>
      </b-form-group>
      <b-button type="submit" class="float-right" variant="primary" disabled>
        Save
      </b-button>
    </b-form> 
  </b-modal>
</template>
